import React, { useContext } from 'react';
import { Button } from '@headlessui/react';
import Avatar from '../elements/Avatar';
import { useNavigate } from 'react-router-dom';
// import { SparklesIcon } from "@heroicons/react/24/solid";
import { UserContext } from '../../../utils/contexts/UserContext';

const ProfileBanner = ({ userData }) => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  // const strengths = [
  //   // 'JavaScript',
  //   // 'Adaptability',
  //   // 'Communication',
  //   // const userData = {
  //   //   name: user?.fullName,
  //   //   profileImage: user?.profileImage || null,
  //   //   age: user?.age,
  //   //   title: user?.title || 'Student',
  //   //   location: user?.country,
  //   // };
  //   // 'Leadership',
  // ];

  return (
    <div className="w-full rounded-xl overflow-hidden border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 h-full p-12">
      <div className="flex justify-between flex-col-reverse gap-2 xl:flex-row">
        <div className=" flex flex-col gap-8 max-w-lg" id="banner-left">
          <div className="flex flex-col gap-4">
            <p className="text-3xl font-semibold text-gray-800 dark:text-gray-100 align-middle capitalize">
              {userData?.first_name}{' '}
              {userData?.middle_name ? userData?.middle_name : ''}{' '}
              {userData?.last_name}
            </p>
            <div className="flex flex-wrap gap-1">
              {/* <div className="text-blue-600 text-sm font-medium dark:text-gray-200 dark:bg-blue-500 bg-blue-100 rounded-full px-4 py-1">
                Student @ University of Washington
              </div> */}
              <div className="text-blue-600 text-sm font-medium dark:text-gray-200 dark:bg-blue-500 bg-blue-100 rounded-full px-4 py-1">
                {userData?.city ? `${userData?.city}, ` : ''}
                {userData?.state ? `${userData?.state}, ` : ''}
                {userData?.country ? `${userData?.country?.name}` : ''}
              </div>
              <div className="text-blue-600 text-sm font-medium dark:text-gray-200 dark:bg-blue-500 bg-blue-100 rounded-full px-4 py-1">
                {new Date(
                  new Date() - new Date(userData?.date_of_birth),
                ).getFullYear() - 1970}{' '}
                years old
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <p className="text-gray-600 text-sm dark:text-gray-400">About</p>
            <p className="text-gray-600 dark:text-gray-300">
              {userData?.bio || 'No bio yet'}
            </p>
          </div>
          {/* <div className="flex flex-col gap-4">
            <p className="text-gray-600 text-sm dark:text-gray-400">
              Strengths
            </p>
            <div className="grid grid-cols-2 gap-2">
              {strengths.map((strength, key) => (
                <div className="flex flex-row gap-2" key={key}>
                  <SparklesIcon className="w-4 h-4 text-blue-600 dark:text-blue-300" />
                  <div className="text-gray-600 dark:text-gray-300">
                    {strength}
                  </div>
                </div>
              ))}
            </div>
          </div> */}
        </div>
        <div
          className="flex flex-col w-full h-auto items-center justify-between max-w-72 "
          id="banner-right"
        >
          <div className="flex justify-center w-full h-full max-h-72">
            <div className="rounded-full p-4 w-full h-full ">
              <Avatar
                name={userData?.first_name}
                profileImage={userData?.avatar_url || userData?.avatar || userData?.profileImage}
                className="w-full h-full text-3xl aspect-square"
              />
            </div>
          </div>
          {user?.uuid === userData?.uuid && (
            <Button
              onClick={() => navigate('/profile/edit')}
              className="flex w-fit cursor-pointer text-center justify-center items-center rounded-md ring-1 ring-gray-300 dark:ring-gray-600 bg-gray-200 dark:bg-gray-600 py-1.5 px-3 text-sm/6 font-semibold text-gray-700 dark:text-white hover:bg-gray-300 dark:hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              Edit Profile
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileBanner;
